import { render } from "./SuccessPwRecovery.vue?vue&type=template&id=bd042e90&scoped=true"
import script from "./SuccessPwRecovery.vue?vue&type=script&lang=js"
export * from "./SuccessPwRecovery.vue?vue&type=script&lang=js"

import "./SuccessPwRecovery.vue?vue&type=style&index=0&id=bd042e90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd042e90"]])

export default __exports__